// src/routes/RequireAdmin.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../context/AuthContext';

const RequireAdmin = ({ children }) => {
  const { user, isLoggedIn, ready } = useAuth();
  const location = useLocation();

  if (!ready) {
    return (
      <Box sx={{ minHeight: '50vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!isLoggedIn) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (!user || user.role !== 'admin') {
    return <Navigate to="/403" replace />;
  }

  return children;
};

export default RequireAdmin;
